import { takeEvery, takeLatest } from 'redux-saga';
import * as ActionTypes from 'constants';
import { call, put } from 'redux-saga/effects';

import {
  sessionWatcher
} from './session-authorization';

import {
  newInteractionWatcher,
  clientAssignWatcher,
  clientFetchWatcher,
  newTaskWatcher,
  newLeadWatcher
} from './client';

import {
  incidentWatchers,
  newImpactWatcher,
} from './client_incidents';

import {
  fetchClientsWithFiltersWatcher
} from './clients';

import { fieldsWatcher } from './fields';
import { rolesWatcher } from './roleManagement';
import { usersWatcher } from './users';
import { plansWatcher } from './plans';
import { subscriptionsWatcher } from './subscriptions';
import { jobsWatcher } from './jobs';
import { featuresWatcher } from './features';
import { tasksWatcher } from './tasks';
import { contactsWatcher } from './contacts';
import { pipelineWatcher } from './pipeline';
import { markersWatcher } from './markers';
import { mapsWatcher } from './maps';
import { mapCreatorWatcher } from './map-creator';
import { salesSiteManagerWatcher } from './sales-site-manager';

function * sendAnalytics(action) {
  try {
    if(process.env.NODE_ENV === 'production' && ga) {
      const items = action.type.split('_');
      ga('send', 'event', items[1], items[0], items.slice(2, items.length).join(' '));
    }
  }
  catch(ex) {
    console.error(ex);
  }
}
function * loggerWatcher() {
  yield * [
    takeEvery('*', sendAnalytics)
  ]
}

export function* rootSaga() {
  yield [
    loggerWatcher(),
    sessionWatcher(),
    clientFetchWatcher(),
    // Client
    newTaskWatcher(),
    newInteractionWatcher(),
    clientAssignWatcher(),
    // Incidents
    incidentWatchers(),
    newImpactWatcher(),
    // Clients
    fetchClientsWithFiltersWatcher(),
    fieldsWatcher(),
    //Roles
    rolesWatcher(),
    //Users
    usersWatcher(),
    //Plans
    plansWatcher(),
    //Subscriptions
    subscriptionsWatcher(),
    //Pipeline
    pipelineWatcher(),
    //Jobs
    jobsWatcher(),
    //Features
    featuresWatcher(),
    //Contacts
    contactsWatcher(),
    //Tasks
    tasksWatcher(),
    //Markers
    markersWatcher(),
    //Maps
    mapsWatcher(),
    //Map Creator
    mapCreatorWatcher(),
    //Sales Site Manager
    salesSiteManagerWatcher()
  ];
}



// WEBPACK FOOTER //
// ./src/common/sagas/index.js